import React from 'react';
import searchNormalIcon from '../../assets/search-normal.svg';

/**
 * Search field at the top of the From/To airport suggestion card.
 * Clears the query without closing the list.
 *
 * Props:
 * - value: string
 * - onChange: (value: string) => void
 * - inputRef?: React.Ref
 * - placeholder?: string
 * - ariaLabel?: string
 */
class AirportSuggestionSearch extends React.Component {
  handleChange = (event) => {
    if (typeof this.props.onChange === 'function') this.props.onChange(event.target.value);
  };

  handleClearMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  handleClear = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (typeof this.props.onChange === 'function') this.props.onChange('');
    const node = this.props.inputRef && this.props.inputRef.current;
    if (node && typeof node.focus === 'function') node.focus();
  };

  render() {
    const value = this.props.value || '';
    const placeholder = this.props.placeholder || 'Search';
    const ariaLabel = this.props.ariaLabel || 'Search airports';
    return (
      <div className="flight-dropdown-search-bar">
        <img src={searchNormalIcon} alt="" className="flight-dropdown-search-icon" />
        <input
          ref={this.props.inputRef}
          type="text"
          placeholder={placeholder}
          className="flight-dropdown-search-input"
          value={value}
          onChange={this.handleChange}
          onClick={(event) => event.stopPropagation()}
          onMouseDown={(event) => event.stopPropagation()}
          onKeyDown={(event) => event.stopPropagation()}
          autoComplete="off"
          aria-label={ariaLabel}
        />
        {value ? (
          <button
            type="button"
            className="flight-dropdown-search-clear"
            aria-label="Clear search"
            onMouseDown={this.handleClearMouseDown}
            onClick={this.handleClear}
          >
            ×
          </button>
        ) : null}
      </div>
    );
  }
}

export default AirportSuggestionSearch;
